import React, { useState } from "react";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import MyBookings from "./bookings";
import Services from "./services";

const BookAService = () => {
  const [tab, setTab] = useState(1);
  return (
    <RouteLayout>
      <div className="flex pl-5">
        <button
          onClick={() => setTab(1)}
          className={`${
            tab === 1 ? "bg-white" : "bg-[#DBDBDB]"
          } border border-gray-600 p-3`}
        >
          Services
        </button>
        <button
          onClick={() => setTab(2)}
          className={`${
            tab === 2 ? "bg-white" : "bg-[#DBDBDB]"
          } border border-gray-600 p-3`}
        >
          My Bookings
        </button>
      </div>

      <div className="p-[20px] bg-white shadow-md rounded-lg">
        {tab === 1 && <Services />}
        {tab === 2 && <MyBookings />}
      </div>
    </RouteLayout>
  );
};

export default BookAService;
